<template>
  <v-layout my-md-12 my-2 class="agentHeader" pa-2>
    <v-flex class="px-4">
      <!-- <v-icon class="icon-agent icon-agent-btn" color="primary" /> -->
      <img src="~/assets/23/avatar.svg" class="avatar-agent" />
    </v-flex>
    <v-flex>
      <h1 class="agent-hdr1 black--text font-weight-medium">
        {{ title }}
      </h1>
      <h2 class="py-1 agent-hdr2" v-html="text"></h2>
    </v-flex>
  </v-layout>
</template>

<script>
import { t } from '@/store/modules/homeDrushim/constantsContent';

export default {
  props: {
    title: {
      type: String,
      required: false,
      default: t('titles.smartAgent.mainTitle'),
    },
    text: {
      type: String,
      required: false,
      default: t('titles.smartAgent.subTitle'),
    },
  },
};
</script>

<style lang="scss" scoped>
.agentHeader {
  max-width: 700px;
  margin: 0 auto;
}

.avatar-agent {
  width: 70px;
}
.agent-hdr1 {
  font-size:22px
}
h2.agent-hdr2 {
  font-size: 16px ;
  line-height: 20px;
  color:#000
}

@media only screen and (min-width: 600px) {
  .avatar-agent {
    width: 115px;
  }
  .agent-hdr1 {
    font-size: 30px;
  }
  h2.agent-hdr2 {
    font-size: 20px;
    line-height: 25px;
      color:#000
  }
}
</style>
